import styled from 'styled-components';

export const Ad = styled.div`
  padding: ${({ padding }) => padding};
  margin: 0 auto;
  text-align: center;

  small {
    display: block;
    max-width: 100%;
    padding-bottom: 3px;
    text-align: center;
  }
`;
